module.exports = __webpack_public_path__ + "img/logo.fdd547c5.png";